import { render, staticRenderFns } from "./Gloria.vue?vue&type=template&id=57bf91a4&scoped=true&"
import script from "./Gloria.vue?vue&type=script&lang=js&"
export * from "./Gloria.vue?vue&type=script&lang=js&"
import style0 from "./Gloria.vue?vue&type=style&index=0&id=57bf91a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bf91a4",
  null
  
)

export default component.exports